import { useState } from "react";
import { Volume2, Bookmark, BookmarkCheck, Search } from "lucide-react";
import expressions from "../data/daily-expressions.json";
import { addBookmark, isBookmarked, removeBookmark } from "../bookmarks";

const categories = [...new Set(expressions.map((e) => e.category))];

export default function Idioms() {
  const [search, setSearch] = useState("");
  const [activeCategory, setActiveCategory] = useState("all");
  const [, forceUpdate] = useState(0);

  const filtered = expressions.filter((e) => {
    const matchSearch = !search || e.expression.toLowerCase().includes(search.toLowerCase()) || e.meaning.toLowerCase().includes(search.toLowerCase());
    const matchCat = activeCategory === "all" || e.category === activeCategory;
    return matchSearch && matchCat;
  });

  function speak(text) {
    if ("speechSynthesis" in window) {
      const u = new SpeechSynthesisUtterance(text);
      u.rate = 0.85; u.lang = "en-US";
      window.speechSynthesis.speak(u);
    }
  }

  function toggleBookmark(e) {
    if (isBookmarked(e.expression)) removeBookmark(e.expression);
    else addBookmark(e.expression, "idiom");
    forceUpdate((n) => n + 1);
  }

  return (
    <div className="space-y-4 page-enter relative">
      <div className="blob blob-amber" style={{ width: 320, height: 320, top: -40, right: -40, opacity: 0.18 }} />
      <div className="blob blob-purple" style={{ width: 260, height: 260, top: 280, left: -40, opacity: 0.15 }} />
      <div className="relative">
        <h1 className="font-display text-4xl md:text-5xl font-normal"><em>Idioms.</em></h1>
        <p className="text-sm text-gray-600 dark:text-gray-300 font-semibold mt-1">{expressions.length} expressions to master</p>
      </div>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search expressions..." className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:border-gold-500 focus:outline-none" />
      </div>

      <div className="flex flex-wrap gap-2">
        <button onClick={() => setActiveCategory("all")} className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all ${activeCategory === "all" ? "bg-ink-900 text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}>All</button>
        {categories.map((c) => (
          <button key={c} onClick={() => setActiveCategory(c)} className={`px-3 py-1.5 rounded-lg text-xs font-semibold capitalize transition-all ${activeCategory === c ? "bg-ink-900 text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}>{c}</button>
        ))}
      </div>

      <div className="space-y-3 page-enter">
        {filtered.map((e, i) => (
          <div key={i} className="bg-white rounded-xl border border-gray-100 p-5 hover:shadow-md transition-all">
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-bold text-gray-900">{e.expression}</h3>
                  <span className="text-[10px] bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full capitalize">{e.category}</span>
                </div>
                <p className="text-sm text-gray-600 mb-2">{e.meaning}</p>
                <p className="text-sm text-gray-400 italic">"{e.example}"</p>
              </div>
              <div className="flex gap-1 flex-shrink-0">
                <button onClick={() => speak(e.expression + ". " + e.example)} className="p-2 text-gray-300 hover:text-gold-700 transition-colors">
                  <Volume2 className="w-4 h-4" />
                </button>
                <button onClick={() => toggleBookmark(e)} className="p-2 transition-colors">
                  {isBookmarked(e.expression) ? <BookmarkCheck className="w-4 h-4 text-gold-700" /> : <Bookmark className="w-4 h-4 text-gray-300 hover:text-gold-700" />}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
